/* eslint-disable */
import {
  Box,
  Text,Tabs, TabList, Tab, TabPanels, TabPanel ,  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbSeparator
} from "@chakra-ui/react";
import { useEffect } from "react";
import { useState } from "react";
import { useSelector,useDispatch } from "react-redux";
import { selectedMenu, setHeaderText } from "../../../redux/actions/actions";
import { useHistory, useParams } from "react-router-dom";
import {
  loadTutorStatisticReports,loadTutorExamScheduleReports
} from "../../../redux/api_calls/apiCalls";
import Statistics from "./Statistics";
import ProfileStatistics from "./ProfileStatistics";
import ExamScheduleStatistics from "./ExamScheduleStatistics";
  import { ChevronRightIcon } from '@chakra-ui/icons'

export default function Reports() {
    const dispatch = useDispatch()
    let { tutorId } = useParams();
    const slider = useSelector(state => state.sliderState.sliderOpen)
    const headerText = useSelector(state => state.headerState.headerText)
    const { tutorStatisticsData } = useSelector(state => state.tutorStatisticsData)
    const [tutorStatisticsList, setTutorStatisticsList] = useState([])
    const { tutorExamScheduleData } = useSelector(state => state.tutorExamScheduleData)
    const [tutorExamScheduleList, setTutorExamScheduleList] = useState([])
    
    useEffect(() => {
        dispatch(setHeaderText('Tutor Reports'))
        dispatch(selectedMenu(7))
        dispatch(loadTutorStatisticReports(tutorId))
        dispatch(loadTutorExamScheduleReports(tutorId))
    }, [])

     useEffect(() => {
        if (tutorStatisticsData) {
            setTutorStatisticsList(tutorStatisticsData)
        }
    }, [tutorStatisticsData])

       useEffect(() => {
        if (tutorExamScheduleData) {
            setTutorExamScheduleList(tutorExamScheduleData)
        }
    }, [tutorExamScheduleData])

    return (
        <Box
            d='flex'
            justifyContent='flex-start'
            alignItems='center'
            flexDirection='column'
            minH='90vh'
            pl={['0', '0', '0', slider ? window.innerWidth < 1400 ? '18vw' : '13vw' : '7.5vw']}
            transition='all 350ms ease'
        >
        <Box width={['95%', '95%', '95%', '80%']}  alignItems='right' textAlign='right' mb='2rem' mt='2rem'>
                <Breadcrumb spacing='8px' separator={<ChevronRightIcon color='gray.500' />}>
                      <BreadcrumbItem>
                        <BreadcrumbLink href="javascript:history.back()">Reports</BreadcrumbLink>
                      </BreadcrumbItem>

                      <BreadcrumbItem isCurrentPage='true'>
                        <BreadcrumbLink href='#' _activeLink={{ color: '#4199e1',fontWeight:'bold',textDecoration:'none' }}>Tutor Reports</BreadcrumbLink>
                      </BreadcrumbItem>

                    </Breadcrumb>
            </Box>
            <Box width={['95%', '95%', '95%', '80%']} justifyContent='space-between' alignItems='center' d='flex' mb='2rem'>
                <Text fontSize={['20px', '25px', '30px', '40px']} d={['none', 'none', 'none', 'flex']} fontWeight='900' style={{ fontFamily: 'Mulish, sans-serif' }}>{headerText}</Text>
            </Box>
            <Box
                d='flex'
                justifyContent='space-between'
                alignItems='flex-start'
                w='80%'
                mb='3rem'
            >
                <Box
                    w='100%'
                    d='flex'
                    flexDir='column'
                >
                 <Tabs width={['100%']}>
                    <TabList style={{ border: 'none' }} variant='unstyled' colorScheme='blue'>
                        <Tab width="30%" _selected={{ color: 'white', bg: '#4199e1',borderRadius:'10px' }} style={{ fontFamily: "Mulish, sans-serif",textTransform:"uppercase" }}>Stats</Tab>
                        <Tab width="30%" _selected={{ color: 'white', bg: '#4199e1',borderRadius:'10px' }} style={{ fontFamily: "Mulish, sans-serif",textTransform:"uppercase" }}>Profile</Tab>
                        <Tab width="30%" _selected={{ color: 'white', bg: '#4199e1',borderRadius:'10px' }} style={{ fontFamily: "Mulish, sans-serif",textTransform:"uppercase" }}>Exam Schedules</Tab>
                    </TabList>

                    <TabPanels>
                        <TabPanel padding="0">
                        <Box
                            w='100%'
                            d='flex'
                            justifyContent='space-between'
                            alignItems='center'
                            mb='1rem'
                            px='1rem'
                            py='1rem'
                        >
                        <Statistics statistics={tutorStatisticsList} />
                        </Box>
                        </TabPanel>
                        <TabPanel padding="0">
                        <Box
                            w='100%'
                            d='flex'
                            justifyContent='space-between'
                            alignItems='center'
                            mb='1rem'
                            px='1rem'
                            py='1rem'
                        >
                            <Text variant='custom' style={{ fontFamily: 'Mulish, sans-serif' }} width='20%'>Name</Text>
                            <Text variant='custom' style={{ fontFamily: 'Mulish, sans-serif' }} width='20%' textAlign='center'>Email</Text>
                            <Text variant='custom' style={{ fontFamily: 'Mulish, sans-serif' }} width='20%' textAlign='center'>Mobile Number</Text>
                            <Text variant='custom' style={{ fontFamily: 'Mulish, sans-serif' }} width='20%' textAlign='center'>No of subjects taken</Text>
                            <Text variant='custom' style={{ fontFamily: 'Mulish, sans-serif' }} width='20%' textAlign='center'>Status</Text>
                        </Box>
                        <ProfileStatistics participants={tutorStatisticsList} />
                        </TabPanel>
                        <TabPanel padding="0">
                        <Box
                            w='100%'
                            d='flex'
                            justifyContent='space-between'
                            alignItems='center'
                            mb='1rem'
                            px='1rem'
                            py='1rem'
                        >
                            <Text variant='custom' style={{ fontFamily: 'Mulish, sans-serif' }} width='12.5%' textAlign='center'>Class</Text>  
                            <Text variant='custom' style={{ fontFamily: 'Mulish, sans-serif' }} width='12.5%' textAlign='center'>Degree</Text>
                            <Text variant='custom' style={{ fontFamily: 'Mulish, sans-serif' }} width='12.5%' textAlign='center'>Specialization</Text>    
                            <Text variant='custom' style={{ fontFamily: 'Mulish, sans-serif' }} width='12.5%' textAlign='center'>Date</Text>                
                            <Text variant='custom' style={{ fontFamily: 'Mulish, sans-serif' }} width='12.5%' textAlign='center'>Time</Text>
                            <Text variant='custom' style={{ fontFamily: 'Mulish, sans-serif' }} width='10%' textAlign='center'>Time Noon</Text>
                            <Text variant='custom' style={{ fontFamily: 'Mulish, sans-serif' }} width='15%' textAlign='center'>Question</Text>
                        </Box>
                        <ExamScheduleStatistics schedules={tutorExamScheduleList} tutorId={tutorId}/>
                        </TabPanel>
                    </TabPanels>
                </Tabs>
                   
                           
                    
                </Box>


            </Box>
        </Box>
    )
}